import {
  Button,
  HStack,
  Icon,
  IconButton,
  IconStatusTypes,
  Text,
  VStack,
} from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import React from 'react';

import {
  StatusSkeleton,
  TextSkeleton,
} from '../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { TableContentItemStatus } from '../../../CustomerDetail/components/SecuritiesTransfer/components/TableTransferRequests/TransferRequestsItem/components/TableContentItemStatus';

interface MainStatusContainerDefaultProps {
  isMobile: boolean;
}

export interface MainStatusContainerProps extends MainStatusContainerDefaultProps {
  statusIcon: Omit<IconStatusTypes.SingleIconProps, 'testId'>;
  statusTitle: string;
  statusDescription?: string;
  onDetailsPress: () => void;
}

export const MainStatusContainer: React.FC<MainStatusContainerProps> = ({
  isMobile,
  statusIcon,
  statusTitle,
  statusDescription,
  onDetailsPress,
}) => {
  if (isMobile) {
    return (
      <VStack mb="stack.xxxs" space="stack.nano" px="inline.xxxs" py="stack.xxxs">
        <HStack justifyContent="space-between" alignItems="center">
          <TableContentItemStatus status={statusTitle} statusIcon={statusIcon} />
          <IconButton
            testId="status-details-button"
            icon="ArrowRight"
            iconSize="xxs"
            p={0}
            backgroundColor="transparent"
            iconColor="brand.tertiary.principal"
            onPress={onDetailsPress}
          />
        </HStack>
        {statusDescription && <Text color="neutral.darkest">{statusDescription}</Text>}
      </VStack>
    );
  }

  return (
    <HStack
      mb="stack.xxxs"
      flex={1}
      alignItems="center"
      justifyContent="space-between"
      background="background"
      px="inline.xxs"
      py="stack.xxxs"
      borderRadius={BoxBorder.heavy}>
      <HStack flex={1} space="inline.xxs" alignItems="center">
        <TableContentItemStatus status={statusTitle} statusIcon={statusIcon} />
        {statusDescription && <Text color="neutral.darkest">{statusDescription}</Text>}
      </HStack>
      <Button
        variant="textLink"
        rightIcon={<Icon name="ChevronRight" size="xxxs" color="brand.tertiary.principal" />}
        onPress={onDetailsPress}
        _text={{
          fontFamily: Typography['fontfamily.base.semibold'],
          color: 'brand.tertiary.principal',
        }}>
        VER DETALHES
      </Button>
    </HStack>
  );
};

export const MainStatusContainerLoading: React.FC<MainStatusContainerDefaultProps> = ({
  isMobile,
}) => {
  if (isMobile) {
    return (
      <VStack mb="stack.xxxs" space="stack.nano" px="inline.xxxs" py="stack.xxxs">
        <HStack justifyContent="space-between" alignItems="center">
          <StatusSkeleton w="100px" />
          <IconButton
            testId="status-details-button"
            icon="ArrowRight"
            iconSize="xxs"
            p={0}
            backgroundColor="transparent"
            iconColor="neutral.medium"
            isDisabled
          />
        </HStack>
        <TextSkeleton />
      </VStack>
    );
  }

  return (
    <HStack
      mb="stack.xxxs"
      alignItems="center"
      justifyContent="space-between"
      background="background"
      px="inline.xxs"
      py="stack.xxxs"
      borderRadius={BoxBorder.heavy}>
      <HStack space="inline.xxs" alignItems="center">
        <StatusSkeleton w="100px" />
        <TextSkeleton />
      </HStack>
      <Button
        variant="textLink"
        color="neutral.medium"
        isDisabled
        rightIcon={<Icon name="ChevronRight" size="xxs" color="neutral.medium" />}>
        VER DETALHES
      </Button>
    </HStack>
  );
};
